import { useEffect } from 'react';

interface useFocusTrapParams {
  isOpen: boolean;
  onClose: () => void;
  selector: string;
  handleEscButton?: boolean;
  handleFocusTrap?: boolean;
}
export const useFocusTrap = ({
  isOpen = false,
  onClose = () => {},
  selector = '',
  handleEscButton = true,
  handleFocusTrap = true,
}: useFocusTrapParams): void => {
  useEffect(() => {
    if (handleEscButton) {
      //handle close modal at ESC key down
      const handleKeyPress = (e: { key: string }) => {
        if (e.key === 'Escape' && isOpen) {
          onClose();
        }
      };

      document.addEventListener('keydown', handleKeyPress);

      return () => {
        document.removeEventListener('keydown', handleKeyPress);
      };
    }

    return undefined;
  }, [isOpen, onClose]);

  useEffect(() => {
    if (handleFocusTrap && isOpen) {
      //handle trap focus
      document.addEventListener('keydown', trapFocus);

      const focusableElements = document
        .querySelector(selector)
        ?.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        ) as NodeListOf<HTMLElement>;
      focusableElements?.[0]?.focus();
    } else {
      document.removeEventListener('keydown', trapFocus);
    }

    return () => {
      document.removeEventListener('keydown', trapFocus);
    };
  }, [isOpen]);

  function trapFocus(event: {
    key: string;
    shiftKey: boolean;
    preventDefault: () => void;
  }) {
    if (selector) {
      const focusableElements = document
        .querySelector(selector)
        ?.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        ) as NodeListOf<HTMLElement>; // Cast esplicito

      const firstElement = focusableElements?.[0];
      const lastElement = focusableElements?.[focusableElements?.length - 1];

      if (event?.key === 'Tab' && firstElement && lastElement) {
        if (event.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus(); // Ora `focus()` è disponibile
            event.preventDefault();
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus(); // Ora `focus()` è disponibile
            event.preventDefault();
          }
        }
      }
    }
  }

  return;
};
